<template>
  <div class="py-1">
    <simple-label
      :id="name"
      :label="label"
      :label-info="labelInfo"
      :required="required"
    ></simple-label>
    <input
      :type="type"
      :id="name"
      :name="name"
      :placeholder="computedPlaceholder"
      :required="required"
      :disabled="disabled"
      :class="css"
      :min="min"
      :max="max"
      @change="onChange"
      :value="value"
      @input="emit"
      @blur="emit"
    />
    <span class="help danger">
      <span
        v-if="useForm && $parent.form.errors.has(name)"
        v-text="$parent.form.errors.get(name)"
      ></span>
    </span>
  </div>
</template>

<script>
import SimpleLabel from "./SimpleLabel";

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    labelInfo: {
      type: String,
      default: "",
      required: false,
    },
    value: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
  },
  components: { SimpleLabel },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {
    emit(ev) {
      this.$emit("input", ev.target.value);
    },
    onChange() {
      if (this.useForm) {
        this.$parent.form.errors.clear(this.name);
      }
    },
  },
  computed: {
    useForm() {
      return this.$parent.form !== undefined;
    },
    css() {
      let css = "";

      if (this.useForm && this.$parent.form.errors.has(this.name)) {
        css = "danger";
      }

      if (this.disabled) {
        css += "bg-gray-100 text-gray-500";
      }

      return css;
    },
    computedPlaceholder() {
      return this.placeholder || this.label;
    },
  },
  mounted() {},
};
</script>

<style></style>
